var axios = require('axios');

var ROOT_URL = 'https://www.googleapis.com/youtube/v3/search';

module.exports = function (options, callback) {
  if (!options.key) {
    throw new Error('Youtube Search expected key, received undefined');
  }

  var params = {
    maxResults: '25',
    part: 'snippet',
    key: options.key,
    order: 'viewCount',
    q: options.term,
    type: 'video',
    videoDefinition: 'high'
  };

  axios.get(ROOT_URL, { params: params })
    .then(function(response) {
      if (callback) { callback(response.data.items); }
    })
    .catch(function(error) {
      console.error(error);
    });
};



// WEBPACK FOOTER //
// ./src/youtube-search.js